import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import OrderFilterWeightInput from '../../../../components/shipment-configuration-widget/weight-input';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { id as weightFilterId, apiKey } from '../../../../filters/options/weight';
import { messages } from './messages';

import style from '../common-styles.module.less';

export const Weight = {
  id: weightFilterId,
  type: OptionFormTypes.TYPE_NUMBER_COMPARISON,
  filterValue: apiKey,
  defaultArgumentValue: { value: 0 },
  displayName: <FormattedMessage {...messages.weight} />,

  render: (criteriaInformations) => {
    const { criterionStateMethods, criterionOperatorOptions } = criteriaInformations;
    const { getCriterionOperator, updateCriterionOperator, getCriterionArgument, updateCriterionArgument, updateCriterionMeta } =
      criterionStateMethods;
    const selectedComparator = getCriterionOperator();
    const comparatorDisplay = selectedComparator.displayName;
    const weightValueObject = getCriterionArgument();
    const weightValue = weightValueObject ? weightValueObject.value : 0;

    return (
      <div className={style['form-criteria-section']}>
        <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
          <DropdownMenuToggler>{comparatorDisplay}</DropdownMenuToggler>
          {criterionOperatorOptions.map((option, index) => (
            <DropdownMenuItem key={index} onClick={() => updateCriterionOperator(option)} selected={option === selectedComparator}>
              {option.displayName}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
        <div className={style['weight-input']}>
          <OrderFilterWeightInput
            onChange={(value, unit) => {
              updateCriterionArgument({ value });
              updateCriterionMeta({ unit });
            }}
            weight={weightValue}
          />
        </div>
      </div>
    );
  },

  mapV2SavedFilterToV3Applied: ({ value }) => ({
    criterionArgumentValue: Number.parseInt(value, 10),
  }),
};
